module.exports = __webpack_public_path__ + "img/big_1_18.cc00dcf0.png";